import Prices from './Prices';

export default Prices;
